import { createSelector } from '@reduxjs/toolkit';

import { getSelectedItemEntries } from '../../store/selectors/getSelectedItemSelector';
import { SelectableItemOfType } from '../selection/types';
import { isTransformableType, TransformableType } from './types';

export type TransformationTargets = {
  [T in TransformableType]: { type: T; entities: SelectableItemOfType<T>[] };
}[TransformableType];

export const getCurrentTransformationTargets = createSelector(
  getSelectedItemEntries,
  (entries): TransformationTargets | null => {
    const type = entries[0]?.type;

    if (entries.length === 0) return null;
    if (entries.some((entry) => entry.type !== type)) return null;

    if (isTransformableType(type)) {
      return { type, entities: entries.map((entry) => entry.item) } as TransformationTargets;
    }

    return null;
  },
);

export const getCurrentTransformationTargetType = createSelector(
  getCurrentTransformationTargets,
  (targets) => targets?.type ?? null,
);

export const isCurrentSelectionTransformable = createSelector(
  getCurrentTransformationTargetType,
  (type) => type !== null,
);
